import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';

function SortableHeaderCell({
  field,
  orderBy,
  order,
  onRequestSort,
  label,
  align = 'left',
}) {
  const isActive = orderBy === field;
  const direction = isActive && order ? order : 'asc';

  return (
    <TableCell align={align}>
      <TableSortLabel
        active={isActive}
        direction={direction}
        onClick={() => onRequestSort(field)}
      >
        <span className="text">{label}</span>
      </TableSortLabel>
    </TableCell>
  );
}

export default SortableHeaderCell;
